export const getAccessToken = (state) => state.auth.accessToken
export const getHasCheckedAuthentication = (state) => state.auth.hasCheckedAuthentication
export const getIsAuthenticated = (state) => state.auth.isAuthenticated
